import {
    DomainAction
} from '../index'

const domain = "Content"

export const Content = {
    getAll: new DomainAction(domain, 'GetAll', DomainAction.methods.get),
    getSingle: new DomainAction(domain, '', DomainAction.methods.get),
    create: new DomainAction(domain, '', DomainAction.methods.post),
    update: new DomainAction(domain, '', DomainAction.methods.put),
    delete: new DomainAction(domain, '', DomainAction.methods.delete),
    getAllSections: new DomainAction(domain, 'GetAllSections', DomainAction.methods.get),
    createSection: new DomainAction(domain, 'CreateSection', DomainAction.methods.post),
    updateSection: new DomainAction(domain, 'UpdateSection', DomainAction.methods.put),
    deleteSection: new DomainAction(domain, 'DeleteSection', DomainAction.methods.delete),
    deleteImage: new DomainAction("SystemMedia", '', DomainAction.methods.delete),
}